import Box from '@zenbusiness/zui/Box';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { addSpaceAndCapitalizeFirstLetter } from '#client/utils/text';

import { LabelStyled } from './Label.styles';

export default function Label({ status, bgColor, color = 'primary' }) {
  return (
    <Box>
      <LabelStyled
        aria-label="label"
        bgColor={bgColor}
      >
        <Text
          color={color}
          size="sm"
          sx={{
            textAlign: 'center'
          }}
        >
          {addSpaceAndCapitalizeFirstLetter(status)}
        </Text>
      </LabelStyled>
    </Box>
  );
}

Label.propTypes = {
  status: PropTypes.string.isRequired,
  bgColor: PropTypes.string.isRequired,
  color: PropTypes.string
};
